module.exports = __webpack_public_path__ + "static/media/leukaemiaUK-light.b50513d6.png";